import { createContext } from 'react';

import { colorTokens } from '../themes/default';
import { ColorTokens } from '../types';

const ColorTokensContext = createContext<ColorTokens>(colorTokens);

export default ColorTokensContext;
